import { WidgetSizeT } from "../../localTypes/WidgetSizeT";

export function WAWidgetSizeToOverviewSize(size: WidgetSizeT) {
  switch (size.h) {
    case 1:
      return "TWO_X_ONE";
    case 2:
      return "TWO_X_TWO";
    case 3:
      return "TWO_X_THREE";
    case 4:
      return "TWO_X_FOUR";
  }
}
